import SurveyAgeCard from './surveyAgeCard.container';
export default SurveyAgeCard